/**
 *
 * @param {{maxWidth: number,maxHeight: number, width: number, height: number}} param0
 */
export default function({ maxWidth, maxHeight, width, height }) {
  if (width >= maxWidth && height >= maxHeight) {
    const widthRatio = width / maxWidth
    const heightRatio = height / maxHeight
    const maxRatio = Math.max(heightRatio, widthRatio)
    return {
      width: width / maxRatio,
      height: height / maxRatio,
      ratio: maxRatio
    }
  }

  if (width >= maxWidth && height < maxHeight) {
    const widthRatio = width / maxWidth
    return {
      width: width / widthRatio,
      height: height / widthRatio,
      ratio: widthRatio
    }
  }

  if (width < maxWidth && height >= maxHeight) {
    const heightRatio = height / maxHeight
    return {
      width: width / heightRatio,
      height: height / heightRatio,
      ratio: heightRatio
    }
  }

  return {
    width: width,
    height: height,
    ratio: 1
  }
}
